/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const augmentedZodDtoOutputOneAgentsItemIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const augmentedZodDtoOutputOneAgentsItemDisplayNameMax = 500;

export const augmentedZodDtoOutputOneAgentsItemInitialsMax = 8;

export const augmentedZodDtoOutputOneAgentsMax = 1000;

export const augmentedZodDtoOutputOneRangeStartRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const augmentedZodDtoOutputOneRangeEndRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const augmentedZodDtoOutputOneTeamIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const augmentedZodDtoOutputOneAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const augmentedZodDtoOutputOneUserIdsItemRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const augmentedZodDtoOutputOneUserIdsMax = 1000;

export const augmentedZodDtoOutputOneSourcesItemUserIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const augmentedZodDtoOutputOneSourcesItemSourceScheduleIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const augmentedZodDtoOutputOneSourcesItemSourceRoutineIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const augmentedZodDtoOutputOneSourcesItemSourceRoutineVersionIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const augmentedZodDtoOutputOneSourcesItemSourcePositionIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const augmentedZodDtoOutputOneSourcesItemSourceOriginalUserIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const augmentedZodDtoOutputOneSourcesItemSourceOverrideIdOneRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const augmentedZodDtoOutputOneSourcesItemStartRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const augmentedZodDtoOutputOneSourcesItemEndRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const augmentedZodDtoOutputOneSourcesMax = 3000;

export const augmentedZodDtoOutputTwoTeamIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const augmentedZodDtoOutputTwoAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const augmentedZodDtoOutputTwoFactsItemScheduleIdOneRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const augmentedZodDtoOutputTwoFactsItemRoutineIdOneRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const augmentedZodDtoOutputTwoFactsItemOriginalUserIdOneRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const augmentedZodDtoOutputTwoFactsMax = 3000;

export const augmentedZodDtoOutputThreeTeamIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const augmentedZodDtoOutputThreeAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const augmentedZodDtoOutputThreeCorrelationIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);

export const AugmentedZodDtoOutput = zod.union([
  zod.object({
    outcome: zod.literal('covered'),
    agents: zod
      .array(
        zod.object({
          id: zod.uuid().regex(augmentedZodDtoOutputOneAgentsItemIdRegExp),
          displayName: zod.string().min(1).max(augmentedZodDtoOutputOneAgentsItemDisplayNameMax),
          initials: zod.string().min(1).max(augmentedZodDtoOutputOneAgentsItemInitialsMax),
        }),
      )
      .max(augmentedZodDtoOutputOneAgentsMax)
      .optional(),
    range: zod
      .object({
        start: zod.iso.datetime({ offset: true }).regex(augmentedZodDtoOutputOneRangeStartRegExp),
        end: zod.iso.datetime({ offset: true }).regex(augmentedZodDtoOutputOneRangeEndRegExp),
      })
      .optional(),
    teamId: zod.uuid().regex(augmentedZodDtoOutputOneTeamIdRegExp),
    at: zod.iso.datetime({ offset: true }).regex(augmentedZodDtoOutputOneAtRegExp),
    userIds: zod
      .array(zod.uuid().regex(augmentedZodDtoOutputOneUserIdsItemRegExp))
      .min(1)
      .max(augmentedZodDtoOutputOneUserIdsMax),
    sources: zod
      .array(
        zod.object({
          userId: zod.uuid().regex(augmentedZodDtoOutputOneSourcesItemUserIdRegExp),
          source: zod.object({
            scheduleId: zod.uuid().regex(augmentedZodDtoOutputOneSourcesItemSourceScheduleIdRegExp),
            routineId: zod.uuid().regex(augmentedZodDtoOutputOneSourcesItemSourceRoutineIdRegExp),
            routineVersionId: zod
              .uuid()
              .regex(augmentedZodDtoOutputOneSourcesItemSourceRoutineVersionIdRegExp),
            positionId: zod.uuid().regex(augmentedZodDtoOutputOneSourcesItemSourcePositionIdRegExp),
            originalUserId: zod
              .uuid()
              .regex(augmentedZodDtoOutputOneSourcesItemSourceOriginalUserIdRegExp),
            originalEligible: zod.boolean(),
            overrideId: zod.union([
              zod.uuid().regex(augmentedZodDtoOutputOneSourcesItemSourceOverrideIdOneRegExp),
              zod.null(),
            ]),
          }),
          start: zod.iso
            .datetime({ offset: true })
            .regex(augmentedZodDtoOutputOneSourcesItemStartRegExp),
          end: zod.iso
            .datetime({ offset: true })
            .regex(augmentedZodDtoOutputOneSourcesItemEndRegExp),
        }),
      )
      .min(1)
      .max(augmentedZodDtoOutputOneSourcesMax),
  }),
  zod.object({
    outcome: zod.literal('uncovered'),
    teamId: zod.uuid().regex(augmentedZodDtoOutputTwoTeamIdRegExp),
    at: zod.iso.datetime({ offset: true }).regex(augmentedZodDtoOutputTwoAtRegExp),
    facts: zod
      .array(
        zod.object({
          scheduleId: zod.union([
            zod.uuid().regex(augmentedZodDtoOutputTwoFactsItemScheduleIdOneRegExp),
            zod.null(),
          ]),
          routineId: zod.union([
            zod.uuid().regex(augmentedZodDtoOutputTwoFactsItemRoutineIdOneRegExp),
            zod.null(),
          ]),
          originalUserId: zod.union([
            zod.uuid().regex(augmentedZodDtoOutputTwoFactsItemOriginalUserIdOneRegExp),
            zod.null(),
          ]),
          reason: zod.enum([
            'no-schedules',
            'outside-sections',
            'before-start',
            'ineligible',
            'ended',
            'archived',
          ]),
        }),
      )
      .max(augmentedZodDtoOutputTwoFactsMax),
  }),
  zod.object({
    outcome: zod.literal('unavailable'),
    teamId: zod.uuid().regex(augmentedZodDtoOutputThreeTeamIdRegExp),
    at: zod.iso.datetime({ offset: true }).regex(augmentedZodDtoOutputThreeAtRegExp),
    reasonCode: zod.enum(['STORAGE_UNAVAILABLE', 'DEPENDENCY_UNAVAILABLE', 'HISTORY_PENDING']),
    correlationId: zod.uuid().regex(augmentedZodDtoOutputThreeCorrelationIdRegExp),
  }),
]);

export type AugmentedZodDtoOutput = zod.input<typeof AugmentedZodDtoOutput>;
export type AugmentedZodDtoOutputOutput = zod.output<typeof AugmentedZodDtoOutput>;
